import { motion } from "framer-motion";

export default function CTASection({ t }) {
  const scrollTo = () => {
    const el = document.querySelector("#contact");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      data-testid="cta-section"
      className="relative py-24 md:py-32 overflow-hidden"
      style={{ background: "#050505" }}
    >
      {/* Glow orbs */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[400px] rounded-full bg-[#0055FF]/10 blur-[150px] pointer-events-none" />

      <div className="relative z-10 max-w-3xl mx-auto px-6 lg:px-8 text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="text-3xl sm:text-4xl lg:text-5xl tracking-tight font-bold text-white font-outfit mb-4">
            {t.cta.title}
          </h2>
          <p className="text-[#94A3B8] text-base md:text-lg font-chivo mb-10 max-w-xl mx-auto">
            {t.cta.subtitle}
          </p>
          <button
            onClick={scrollTo}
            data-testid="cta-contact-button"
            className="bg-[#0055FF] hover:bg-[#0066FF] text-white px-10 py-4 rounded-full font-bold transition-all duration-300 shadow-[0_0_25px_rgba(0,85,255,0.5)] hover:shadow-[0_0_40px_rgba(0,240,255,0.6)] font-outfit text-base tracking-wide"
          >
            {t.cta.button}
          </button>
        </motion.div>
      </div>
    </section>
  );
}
